let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fyMns")).then(() => parcelRequire('6quX4'));